import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getServer } from "../consts";

const photosApi = createApi({
  reducerPath: "photos",
  baseQuery: fetchBaseQuery({
    baseUrl: getServer(),
  }),
  endpoints: (builder) => {
    return {
      fetchPhotos: builder.query({
        query: (album) => {
          return {
            url: "photos",
            method: "GET",
            params: { albumId: album.id },
          };
        },
        providesTags: (result, error, album) => {
          return [{ type: "Photo", id: album.id }];
        },
      }),
      addPhoto: builder.mutation({
        query: (photo) => {
          return {
            url: "photos/",
            method: "POST",
            body: { ...photo },
          };
        },
        invalidatesTags: (result, error, photo) => {
          return [{ type: "Photo", id: photo.albumId }];
        },
      }),
      removePhoto: builder.mutation({
        query: (photo) => {
          return {
            url: `photos/${photo.id}`,
            method: "DELETE",
          };
        },
        invalidatesTags: (result, error, photo) => {
          return [{ type: "Photo", id: photo.albumId }];
        },
      }),
    };
  },
});

const { useFetchPhotosQuery, useAddPhotoMutation, useRemovePhotoMutation } =
  photosApi;
export {
  photosApi,
  useFetchPhotosQuery,
  useAddPhotoMutation,
  useRemovePhotoMutation,
};
